import { render, staticRenderFns } from "./Gradation.vue?vue&type=template&id=56dfba4b&"
import script from "./Gradation.vue?vue&type=script&lang=js&"
export * from "./Gradation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports